import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import TableSortLabel from "@mui/material/TableSortLabel";
import TextField from "@mui/material/TextField";
import {
  List,
  ListItem,
  ListItemText,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import InputAdornment from "@mui/material/InputAdornment";
import { IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from '@mui/material';
import { useAcademicYear } from "./AcademicYearContext";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function CreateSale({
  studentId1,
  studentName,
  selectedSalesId,
  gradeName,
  sectionName,
  deleteFlag,
  setOpenComponent,
  setOpenComponentCreateSale,
  getSales,
  statusCreatedId,
}) {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [product, setProduct] = useState([]);
  const [salesId, setSalesId] = useState(null);
  const [userId, setUserId] = useState();
  // const [academicYearId, setAcademicYearId] = useState(0);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("sales_details_id");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [tableData, setTableData] = useState([]);
  const [selectedQuantity, setSelectedQuantity] = useState({});
  const [validationErrors, setValidationErrors] = useState(false);
  const [currentQuantity, setCurrentQuantity] = useState({});
  const [totalPrice, setTotalPrice] = useState(0);
  const [salesDetails, setSalesDetails] = useState(null);
  const [markedForDelete, setMarkedForDelete] = useState([]);
  const [saleStatus, setSaleStatus] = useState([]);
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const [paidStatusId, setPaidStatusId] = useState(null);
  const [issuedStatusId, setIssuedStatusId] = useState(null);
  const [createdStatusId, setCreatedStatusId] = useState(null);
  const [openProduct, setOpenProduct] = useState(false);
  const [error, setError] = useState(""); // Error message state
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [searchStudent, setSearchStudent] = useState("");
  // Typing alone does nothing now — the fetch effect below depends on this
  // applied value, which is only set (from searchStudent) when Go is
  // clicked or Enter is pressed in the search box.
  const [appliedSearchStudent, setAppliedSearchStudent] = useState("");
  const [searchResultsForStudent, setSearchResultsForStudent] = useState([]);
  const [studentName1, setStudentName1] = useState(studentName);
  const [gradeName1, setGradeName1] = useState(gradeName);
  const [sectionName1, setSectionName1] = useState(sectionName);
  const [studentId, setStudentId] = useState(studentId1);
  const [debouncedStudent, setDebouncedStudent] = useState("");
  const [openStudent, setOpenStudent] = useState(false);
  const [loadingStudent, setLoadingStudent] = useState(false); // Loading state
  const [loadingProduct, setLoadingProduct] = useState(false); // Loading state
  const [filteredStudentData, setFilteredStudentData] = useState([]);
  // Debounced mirror of searchQuery — filtering `allProducts` below depends
  // on this instead of searchQuery directly, so the filter doesn't re-run
  // on every keystroke.
  const [appliedSearchQuery, setAppliedSearchQuery] = useState("");
  const [allProducts, setAllProducts] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [productSearchError, setProductSearchError] = useState("");


   const navigate = useNavigate();
   const { academicYearId } = useAcademicYear();

   useEffect(() => {
     console.log("Received Academic Year ID:", academicYearId);
   }, [academicYearId]);
 
  
  

  const handleProceed = () => {
       // ✅ Validation: Check if staff is selected but no products
  if (studentName1 && product.length === 0) {
    setProductSearchError("Please select product(s) before proceeding.");
    return;
  }
    setOpenComponent(false);
    setOpenComponentCreateSale(false);

    setTimeout(() => {
      getSales();
    }, 100);
  };

  const handleCloseProduct = () => {
    setOpenProduct(false);
  };

  const handleCloseStudent = () => {
    setOpenStudent(false);
  };

  useEffect(() => {
    const fetchUserData = async () => {
      const email = localStorage.getItem("user_email");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`,
          { email },
          { headers: { user_email: email } }
         
        );
        if (response.status === 200) {
          setUserId(response.data.user.user_id);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUserData();
  }, []);

 

  // // Fetch products from the backend API
  // const fetchProducts = async (query) => {
  //   setLoadingProduct(true);
  //   try {
  //     const response = await fetch(
  //       `${
  //         process.env.REACT_APP_JHS_DEVELOPMENT
  //       }/storepurchase/getsearchresult?search=${encodeURIComponent(query)
  
  //       }`
  //     );
  //     if (!response.ok) {
  //       throw new Error("Failed to fetch products");
  //     }
  //     const data = await response.json();
  //     // Function to sanitize strings by trimming and collapsing spaces

  //     const filteredData = data.filter((row) => {
  //       const searchTerms = searchQuery
  //         .toLowerCase()
  //         .split(" ")
  //         .filter(Boolean); // Split on spaces and remove empty strings

  //       return searchTerms.every(
  //         (term) =>
  //           (row.product_id &&
  //             row.product_id.toString().toLowerCase().includes(term)) ||
  //           (row.product_name &&
  //             row.product_name.toLowerCase().includes(term)) ||
  //           (row.brand_name && row.brand_name.toLowerCase().includes(term)) ||
  //           (row.attribute_name &&
  //             row.attribute_name.toLowerCase().includes(term)) ||
  //           (row.attribute_value &&
  //             row.attribute_value.toLowerCase().includes(term)) ||
  //           (row.price && row.price.toString().toLowerCase().includes(term)) ||
  //           (row.quantity &&
  //             row.quantity.toString().toLowerCase().includes(term))
  //       );
  //     });

  //     setSearchResults(filteredData);
  //   } catch (error) {
  //     console.error("Error fetching products:", error);
  //   }
  //   finally{
  //     setLoadingProduct(false);
  //   }
  // };

  useEffect(() => {
  const fetchProducts = async () => {
    setLoadingProduct(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/getsearchresult`
      );
      if (!response.ok) throw new Error("Failed to fetch products");
      const data = await response.json();
      setAllProducts(data);
      setSearchResults([]); // initially show nothing
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoadingProduct(false);
    }
  };

  fetchProducts();
}, []);

useEffect(() => {
  if (!appliedSearchQuery.trim()) {
    setSearchResults([]);
    return;
  }

  const searchTerms = appliedSearchQuery.toLowerCase().split(" ").filter(Boolean);

  const filtered = allProducts.filter((row) =>
    searchTerms.every(
      (term) =>
        (row.product_id &&
          row.product_id.toString().toLowerCase().includes(term)) ||
        (row.product_name &&
          row.product_name.toLowerCase().includes(term)) ||
        (row.brand_name && row.brand_name.toLowerCase().includes(term)) ||
        (row.attribute_name &&
          row.attribute_name.toLowerCase().includes(term)) ||
        (row.attribute_value &&
          row.attribute_value.toLowerCase().includes(term)) ||
        (row.price && row.price.toString().toLowerCase().includes(term)) ||
        (row.quantity && row.quantity.toString().toLowerCase().includes(term))
    )
  );

  setSearchResults(filtered);
}, [appliedSearchQuery, allProducts]);



  // Previously this fetched the ENTIRE institute roster once (no search
  // term) and filtered it client-side. The endpoint falls back to a plain
  // LIMIT (1000) when no search term is sent, ordered by student_id
  // ascending — so once an institute grows past that many students, anyone
  // admitted after roughly the 1000th-lowest student_id was silently never
  // fetched at all, and no amount of correct client-side matching could
  // find them. Search the server with the actual typed term instead (like
  // ReturnSale.js already does for the same endpoint), so filtering happens
  // before any limit is applied.
  //
  // Search is explicit now (Go button / Enter, see handleApplyStudentSearch)
  // rather than firing on every keystroke — this effect only depends on
  // appliedSearchStudent, which changes just once per submitted search.
  // Still cached by term so re-submitting the same search is free.
  const studentSearchCacheRef = React.useRef(new Map());

  useEffect(() => {
    const term = appliedSearchStudent.trim();
    if (!term) {
      setFilteredStudentData([]);
      return;
    }

    const cacheKey = term.toLowerCase();
    const cached = studentSearchCacheRef.current.get(cacheKey);
    if (cached) {
      setFilteredStudentData(cached);
      return;
    }

    const fetchStudents = async () => {
      setLoadingStudent(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/getsearchresultforstudent?search=${encodeURIComponent(term)}`
        );
        if (!response.ok) throw new Error("Failed to fetch students");
        const data = await response.json();

        // Server already narrows by the whole term; re-check client-side
        // with per-word/any-field matching as a safety net (mirrors
        // ReturnSale.js), in case the deployed function only does a
        // single-substring match rather than word-by-word.
        const searchTerms = cacheKey.split(" ").filter(Boolean);
        const filtered = (Array.isArray(data) ? data : []).filter((row) =>
          searchTerms.every(
            (word) =>
              (row.id && row.id.toString().toLowerCase().includes(word)) ||
              (row.first_name && row.first_name.toLowerCase().includes(word)) ||
              (row.father_name && row.father_name.toLowerCase().includes(word)) ||
              (row.mother_name && row.mother_name.toLowerCase().includes(word)) ||
              (row.last_name && row.last_name.toLowerCase().includes(word)) ||
              (row.role_name && row.role_name.toLowerCase().includes(word)) ||
              (row.grade_name && row.grade_name.toLowerCase().includes(word)) ||
              (row.section_name && row.section_name.toLowerCase().includes(word)) ||
              (row.contact_no && row.contact_no.toString().includes(word))
          )
        );

        studentSearchCacheRef.current.set(cacheKey, filtered);
        setFilteredStudentData(filtered);
      } catch (error) {
        console.error("Error:", error);
        setFilteredStudentData([]);
      } finally {
        setLoadingStudent(false);
      }
    };

    fetchStudents();
  }, [appliedSearchStudent]);

  const handleApplyStudentSearch = () => {
    setAppliedSearchStudent(searchStudent.trim());
  };

  const handleStudentSearchKeyDown = (event) => {
    if (event.key === "Enter") {
      handleApplyStudentSearch();
    }
  };

  // Product search is auto-filtering again (debounced), not Go-gated —
  // filtering is entirely client-side over the already-fetched allProducts,
  // so there's no DB call to save by waiting for an explicit submit; the
  // debounce here just avoids re-running the filter on every single
  // keystroke.
  useEffect(() => {
    const handle = setTimeout(() => {
      setAppliedSearchQuery(searchQuery.trim());
    }, 300);
    return () => clearTimeout(handle);
  }, [searchQuery]);



  // // Debounce logic
  // useEffect(() => {
  //   const handler = setTimeout(() => {
  //     setDebouncedQuery(searchQuery);
  //   }, 300); // Adjust the debounce delay as needed (e.g., 300ms)

  //   return () => {
  //     clearTimeout(handler); // Clear the timeout on component unmount or query change
  //   };
  // }, [searchQuery]);

  // // Fetch products whenever the debounced query changes
  // useEffect(() => {
  //   if (debouncedQuery) {
  //     fetchProducts(debouncedQuery);
  //   }
  // }, [debouncedQuery]);

  // useEffect(() => {
  //   const handler = setTimeout(() => {
  //     setDebouncedStudent(searchStudent);
  //   }, 300); // Adjust the debounce delay as needed (e.g., 300ms)

  //   return () => {
  //     clearTimeout(handler); // Clear the timeout on component unmount or query change
  //   };
  // }, [searchStudent]);

  // useEffect(() => {
  //   if (debouncedStudent) {
  //     fetchStudentData(debouncedStudent);
  //   }
  // }, [debouncedStudent]);

  useEffect(() => {
    getProduct();
  }, []);

  useEffect(() => {
    getProduct();
  }, [studentId, academicYearId]);
  const getProduct = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT +
          "/storepurchase/getInventoryRefund",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials:'include',
          body: JSON.stringify({
            student_id: studentId,
            academic_year_id:academicYearId,
          }),
        }
      );

       // If the response status is 401, call signOut
       if (response.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin");
        return; // Stop further execution
      }

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }


      const data = await response.json();

      // Filter out products where the description is "Paid" or "Issued"
      const filteredData = data.filter(
        (item) => item.description !== "Paid" && item.description !== "Issued" && item.description !== "Refunded" && item.description !== "Partial Refund"
      );

      // Update state with filtered data
      setProduct(filteredData);
      setTableData(filteredData);

      // Handle sales ID and sales details only if there are valid products
      if (filteredData.length > 0) {
        setSalesId(filteredData[0].sales_id);
        setSalesDetails(filteredData[0].sales_details_id);
      } else {
        // Clear these states if no valid products remain
        setSalesId(null);
        setSalesDetails(null);
      }
    } catch (error) {
      console.error("Error fetching refund data:", error);
    }
  };

  const getSaleStatus = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/getSalesStatus`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
    

      const data = await response.json();

      // Extract specific sale_status_id for descriptions "Paid" and "Issued"
      const createdStatus =
        data.find((item) => item.description === "Created")?.sales_status_id ||
        null;
      const paidStatus =
        data.find((item) => item.description === "Paid")?.sales_status_id ||
        null;
      const issuedStatus =
        data.find((item) => item.description === "Issued")?.sales_status_id ||
        null;

      // Set the complete data and the extracted IDs in state
      setSaleStatus(data);
      setCreatedStatusId(createdStatus);
      setPaidStatusId(paidStatus);
      setIssuedStatusId(issuedStatus);
    } catch (error) {
      console.error("Error fetching sales status:", error);
    }
  };

  useEffect(() => {
    getSaleStatus();
  }, []);

  // Handle search input change
  const handleSearchChange = (event) => {
 setSearchQuery(event.target.value);
  };

  const handleInput = () => {
    setOpenStudent(true);
  };

  // const handleSearchForStudent = (event) => {
  //   const student = event.target.value;
  //   setSearchStudent(student);
  //   if (student.length > 0) {
  //     fetchStudentData(student);
  //   } else {
  //     setSearchResultsForStudent([]);
  //   }
  // };

  // Handle product selection from search results
  const handleProductSelect = (product) => {
    // Check if the product is already in the table data
    const isAlreadyAdded = tableData.some(
      (item) => item.product_id === product.product_id
    );

    if (isAlreadyAdded) {
      // Show an error message for duplicate products
      setError("This product is already added.");
      setSnackbarOpen(true);

      return; // Exit the function to avoid further execution
    }

    // Check if the product stock is zero or less
    if (product.quantity <= 0) {
      setError("This product is out of stock.");
      setSnackbarOpen(true);
      console.log("Error: Out of stock.");
      return; // Exit the function to avoid further execution
    }

    // Add the product to the table
    setTableData((prev) => [...prev, product]);
    setSearchQuery(""); // Clear search input
    setAppliedSearchQuery(""); // Clear applied search so results list hides
    setSearchResults([]); // Clear search results
    handleRowClick(product);
    setError(""); // Clear any existing error message
  };

  const handleStudentSelect = (student) => {
    setStudentId(student.id);

    setStudentName1(`${student.first_name} ${student.last_name}`);
    setGradeName1(student.grade_name);
    setSectionName1(student.section_name);
    setSearchStudent(""); // Clear search input
    setAppliedSearchStudent(""); // Clear applied search so results list hides
    setSearchResultsForStudent([]); // Clear search results
    setError(""); // Clear any existing error message
    setSalesId(null)
  };

  const handleCloseSnackbar = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  useEffect(() => {
    const calculatedTotalPrice = product.reduce((accumulator, row) => {
      const rowTotalPrice = row.price * row.quantity;
      return accumulator + rowTotalPrice;
    }, 0);

    setTotalPrice(calculatedTotalPrice); // Update the state with the new total price
  }, [product]); // Recalculate when product changes

  // Handle row click to make the POST request
  const handleRowClick = async (product) => {
    try {
      // First, create a new sale entry
      const createResponse = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/addSale`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
      
          body: JSON.stringify({
            studentId,
            academicYearId,
            totalPrice,
            created_by: userId,
            sale_status_id: createdStatusId,
            salesId,
            staff_id: userId,
          }),
        }
      );

      const createResult = await createResponse.json();

      // Extract sales ID from the response
      const newSalesId = createResult.data.sales_id; // Assuming sales_id is returned in the response
      setSalesId(newSalesId); // Update state with new sales ID
      // setSelectedSalesId(newSalesId)

      // Send sales details
      const detailsResponse = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/addSaleDetails`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          
          body: JSON.stringify({
            product_id: product.product_id,
            price: product.price,
            quantity: 1,
            sales_id: newSalesId, // Use the new sales ID
            created_by: userId,
          }),
        }
      );

      const detailsResult = await detailsResponse.json();

      getProduct();
      setProductSearchError("");
    } catch (error) {
      console.error("Error:", error);
      // alert('An error occurred while processing the request.');
    }
  };


  const handleRowDeleteClick = (sale) => {
    setMarkedForDelete((prev) => {
      const isAlreadyMarked = prev.includes(sale);
      const updatedMarkedForDelete = isAlreadyMarked
        ? prev.filter((id) => id !== sale) // Remove if already marked
        : [...prev, sale]; // Add if not marked

      // Recalculate total price excluding rows in updatedMarkedForDelete
      const calculatedTotalPrice = product.reduce((accumulator, row) => {
        if (!updatedMarkedForDelete.includes(row.sales_details_id)) {
          return accumulator + row.price * row.quantity;
        }
        return accumulator; // Exclude marked rows
      }, 0);

      setTotalPrice(calculatedTotalPrice); // Update totalPrice

      // Update selectedRow based on marking status
      if (isAlreadyMarked) {
        setSelectedRow(null); // Clear selection if unselecting
      } else {
        setSelectedRow({ sale }); // Update selection
      }

      return updatedMarkedForDelete; // Update markedForDelete state
    });
  };

  useEffect(() => {
    console.log("Updated marked for delete:", markedForDelete);
  }, [markedForDelete]);

  const handleBatchDelete = () => {
    if(salesId){
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
    setMarkedForDelete("");
  };

  const handleDeleteConfirm = async () => {
    if (markedForDelete.length === 0) return; // Ensure there are selected rows

    try {
      // Iterate over each sales_details_id to delete them
      for (const sale of markedForDelete) {
        const response = await fetch(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/deleteSaleDetails`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
            },
            credentials:'include',
            body: JSON.stringify({ sales_details_id: sale }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to delete sale details."); // Handle errors
        }

        if (response.status === 401) {
          console.warn("Unauthorized access. Redirecting to Sign In...");
          navigate("/signin");
          return; // Stop further execution
        }
        const result = await response.json();
      }
      // Refresh product data after deletion
      getProduct();

      // Clear the selected rows and close the dialog
      setMarkedForDelete([]);
      setOpen(false);
      setTimeout(() => {
        setSelectedRow(null);
      }, 1000);
    } catch (error) {
      console.error("Error deleting sale details:", error);
      setErrorMessage(error.message); // Display error message
    }
  };

  // Function to delete sale details by sales_details_id
  const deleteSaleDetails = async (salesDetailsId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/deleteSaleDetails`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          credentials:'include',
          body: JSON.stringify({ sales_details_id: salesDetailsId }),
        }
      );


      if (response.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin");
        return; // Stop further execution
      }

      if (!response.ok) {
        throw new Error(
          `Failed to delete sale details with ID ${salesDetailsId}.`
        );
      }

      console.log(
        `Sale details with ID ${salesDetailsId} deleted successfully.`
      );
    } catch (error) {
      console.error("Error deleting sale details:", error);
      setErrorMessage(error.message);
    }
  };

  const deleteInvalidProducts = async () => {
    try {
      if (!product || product.length === 0) {
        console.warn("deleteData is empty or undefined.");
        return;
      }

      // Iterate through each object in the deleteData array
      for (const data of product) {
        // Ensure required fields exist
        if (
          !data.sales_details_id ||
          !data.stock ||
          data.description !== "Created"
        ) {
          continue;
        }

        // Parse `sales_details_id` and `stock` into arrays
        const salesDetailsIds = data.sales_details_id.split(",");
        const stocks = data.stock.split(",");

        // Find indices where stock is "0"
        const invalidIndices = stocks
          .map((stock, index) => (Number(stock) === 0 ? index : -1))
          .filter((index) => index !== -1);

        // Get the corresponding `sales_details_id` for invalid products
        const invalidSalesDetailsIds = invalidIndices.map(
          (index) => salesDetailsIds[index]
        );

        // Delete products where stock is "0" and description is "Created"
        for (const salesDetailsId of invalidSalesDetailsIds) {
          await deleteSaleDetails(salesDetailsId); // Your function to delete the product
        }
      }

      // Refresh product data after deletion
      // await getProduct();
    } catch (error) {
      console.error("Error during invalid product deletion:", error);
      setErrorMessage(error.message);
    }
  };

  // useEffect to delete invalid products when selectedSalesId is present
  useEffect(() => {
    if (deleteFlag) {
      deleteInvalidProducts(); // Call to delete invalid products if selectedSalesId is present
    }
  }, [deleteFlag]); // Dependency on selectedSalesId



  // Handle sorting
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = () => {
    return product.slice().sort((a, b) => {
      const aValue = a[orderBy];
      const bValue = b[orderBy];
      if (aValue < bValue) return order === "asc" ? -1 : 1;
      if (aValue > bValue) return order === "asc" ? 1 : -1;
      return 0;
    });
  };

  // Handle pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleQuantityChange = async (
    salesDetailsId,
    value,
    maxQuantity,
    productId
  ) => {
    // Parse the input to a number
    const numericValue = parseInt(value, 10);

    // Step 1: Validation checks
    if (value === "" || isNaN(numericValue)) {
      setValidationErrors((prev) => ({
        ...prev,
        [salesDetailsId]: `Quantity is required and must be between 1 and ${maxQuantity}`,
      }));
      setSelectedQuantity((prev) => ({
        ...prev,
        [salesDetailsId]: "",
      }));
      return;
    }

    if (numericValue < 1) {
      setValidationErrors((prev) => ({
        ...prev,
        // [salesDetailsId]: "Quantity must be at least 1.",
      }));
      return;
    }

    if (numericValue > maxQuantity) {
      setValidationErrors((prev) => ({
        ...prev,
        [salesDetailsId]: `Quantity cannot exceed available stock.`,
      }));
      return;
    }

    // Step 2: Clear validation errors if all checks pass
    setValidationErrors((prev) => ({
      ...prev,
      [salesDetailsId]: null,
    }));

    // Step 3: Update the selected quantity in the local state
    setSelectedQuantity((prev) => ({
      ...prev,
      [salesDetailsId]: numericValue,
    }));

    try {
      // Update sales quantity in the backend
      const updateResponse = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/updateQuantity`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          credentials:'include',
          body: JSON.stringify({
            sales_details_id: salesDetailsId,
            quantity: numericValue,
            updated_by: userId,
            updated_timestamp: new Date(),
          }),
        }
      );

      if (!updateResponse.ok) {
        throw new Error("Failed to update sales data");
      }

      getProduct();
      setCurrentQuantity((prev) => ({
        ...prev,
        [salesDetailsId]: numericValue,
      }));
      // updateTotalPrice();
    } catch (error) {
      console.error("Error during update:", error);
      alert(error.message);
    }
  };

  return (
    <div>
      {!studentName && (
        <div className="create_search">
          {/* Search Field and Proceed Button */}
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className="create_search1">
              <TextField
                sx={{ minWidth: 600, marginBottom: "4px", }}
                label="Student Search"
                variant="outlined"
                fullWidth
                value={searchStudent}
                onChange={(e) => setSearchStudent(e.target.value)}
                onKeyDown={handleStudentSearchKeyDown}
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        type="button"
                        aria-label="search"
                        onClick={handleApplyStudentSearch}
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      {loadingStudent ? <CircularProgress size={18} /> : null}
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <Button
              onClick={handleApplyStudentSearch}
              style={{
                background: "#0A64A2",
                color: "#fff",
                marginLeft: "8px",
                marginBottom: "4px",
                minWidth: "auto",
                paddingTop: "6px",
                paddingBottom: "6px",
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
            >
              Go
            </Button>
          </div>
        </div>
      )}
{appliedSearchStudent.trim() !== "" && filteredStudentData.length > 0 && (
  <List
    sx={{
      border: "1px solid #ccc",
      borderRadius: "4px",
      padding: "0",
      width: 600,
    }}
  >
    {filteredStudentData.map((student) => (
      <ListItem
        button
        key={student.id}
        onClick={() => handleStudentSelect(student)}
      >
        <ListItemText primary={student.first_name} />
         <ListItemText
          primary={student.father_name ? student.father_name : student.mother_name}
        />
        <ListItemText primary={student.last_name} />
        <ListItemText primary={student.grade_name} />
        <ListItemText primary={student.section_name} />
      </ListItem>
    ))}
  </List>
)}

      <div className="main_title1">
        Student Name: {studentName1} &nbsp;&nbsp; Grade: {gradeName1}{" "}
        &nbsp;&nbsp; Section: {sectionName1}
      </div>

      <div
        style={{
          margin: "20px 0",
          fontSize: 15,
          fontWeight: "bold",
          color: "#0A64A2",
          paddingTop: "0",
        }}
      >
          Indent ID: {statusCreatedId === createdStatusId ? selectedSalesId : salesId}
      </div>

      <div className="create_search">
        {/* Search Field and Proceed Button */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <div className="create_search1">
            <TextField
              sx={{ minWidth: 700, marginBottom: "4px" }}
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={studentName1 ? handleSearchChange : handleInput} // Conditional onChange
              label={productSearchError ? productSearchError : "Product Search"}
              error={!!productSearchError}
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton
                      type="button"
                      aria-label="search"
                      onClick={!studentName1 ? handleInput : undefined}
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    {loadingProduct ? <CircularProgress size={18} /> : null}
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className="sale-div">
            <div className="sale-delete-div">
              <Button
                variant="contained"
                color="primary"
                onClick={handleProceed}
                className="sale-delete-btn"
              >
                OK
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleBatchDelete}
                className="sale-delete-btn"
              >
                Delete
              </Button>
            </div>
          </div>
        </div>

      {appliedSearchQuery.trim() !== "" && searchResults.length > 0 && (
  <List
    sx={{
      border: "1px solid #ccc",
      borderRadius: "4px",
      padding: "0",
      width: 700,
    }}
  >
    {searchResults.map((product) => (
      <ListItem
        button
        key={product.id}
        onClick={() => handleProductSelect(product)}
      >
        <ListItemText primary={product.product_name} />
        <ListItemText primary={product.attribute_name} />
        <ListItemText primary={product.attribute_value} />
        <ListItemText primary={product.price} />
        <ListItemText primary={product.quantity} />
      </ListItem>
    ))}
  </List>
)}

      </div>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 750 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>
              <TableSortLabel
                  active={orderBy === "sales_details_id"}
                  direction={orderBy === "sales_details_id" ? order : "asc"}
                  onClick={() => handleSort("sales_details_id")}
                >
                Sl.No</TableSortLabel></StyledTableCell>
              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "product_name"}
                  direction={orderBy === "product_name" ? order : "asc"}
                  onClick={() => handleSort("product_name")}
                >
                  Product Name
                </TableSortLabel>
              </StyledTableCell>
              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "attribute_name"}
                  direction={orderBy === "attribute_name" ? order : "asc"}
                  onClick={() => handleSort("attribute_name")}
                >
                  Attribute Name
                </TableSortLabel>
              </StyledTableCell>
              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "attribute_value"}
                  direction={orderBy === "attribute_value" ? order : "asc"}
                  onClick={() => handleSort("attribute_value")}
                >
                  Attribute Value{" "}
                </TableSortLabel>
              </StyledTableCell>
              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "price"}
                  direction={orderBy === "price" ? order : "asc"}
                  onClick={() => handleSort("price")}
                >
                  Price
                </TableSortLabel>
              </StyledTableCell>
              <StyledTableCell align="center">
              <TableSortLabel
                  active={orderBy === "quantity"}
                  direction={orderBy === "quantity" ? order : "asc"}
                  onClick={() => handleSort("quantity")}
                >
                
                  Quantity{" "}
        </TableSortLabel>
              </StyledTableCell>

              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "quantity"}
                  direction={orderBy === "quantity" ? order : "asc"}
                  onClick={() => handleSort("quantity")}
                >
                  Quantity In Stock
                </TableSortLabel>
              </StyledTableCell>
              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "total_price"}
                  direction={orderBy === "total_price" ? order : "asc"}
                  onClick={() => handleSort("total_price")}
                >
                  Total Price{" "}
                </TableSortLabel>
              </StyledTableCell>
              <StyledTableCell align="center"></StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData()
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                const rowTotalPrice = row.price * row.quantity; // Calculate total price for current row
                return (
                  <StyledTableRow key={row.id}>
                    <StyledTableCell
                      align="center"
                      component="th"
                      scope="row"
                      className="table-cell-border"
                    >
                      {row.sales_details_id}
                      {markedForDelete.includes(row.sales_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      {row.product_name}
                      {markedForDelete.includes(row.sales_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      {row.attribute_name}
                      {markedForDelete.includes(row.sales_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      {row.attribute_value}
                      {markedForDelete.includes(row.sales_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      {row.price}
                      {markedForDelete.includes(row.sales_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      <div>
                        <input
                          type="number"
                          value={
                            selectedQuantity[row.sales_details_id] !== undefined
                              ? selectedQuantity[row.sales_details_id]
                              : row.quantity || 1 // Fallback to row.quantity if state is undefined
                          }
                          onChange={(e) =>
                            handleQuantityChange(
                              row.sales_details_id,
                              e.target.value,
                              row.stock,
                              row.product_id
                            )
                          }
                          style={{ width: "60px" }}
                          defaultValue={1}
                        />
                        {validationErrors[row.sales_details_id] && (
                          <div style={{ color: "red", marginTop: "5px" }}>
                            {validationErrors[row.sales_details_id]}
                          </div>
                        )}
                      </div>
                      {markedForDelete.includes(row.sales_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      {row.stock}
                      {markedForDelete.includes(row.sales_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      {rowTotalPrice.toFixed(2)}
                      {markedForDelete.includes(row.sales_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>{" "}
                    {/* Display calculated total price */}
                    <StyledTableCell
                      align="center"
                      style={{ lineHeight: "10px", padding: "5px" }}
                    >
                      <IconButton
                        color="black"
                        onClick={() =>
                          handleRowDeleteClick(row.sales_details_id)
                        }
                      >
                        <DeleteIcon />
                      </IconButton>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}

            {/* Row to display total price */}
            <TableRow>
              <TableCell
                colSpan={9}
                align="right"
                sx={{
                  fontWeight: "bold",
                  fontSize: "0.9rem",
                  color: "#695a5a",
                  padding: "13px",
                  paddingRight: "70px",
                }}
              >
                Total Price : {totalPrice.toFixed(2)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        style={{ backgroundColor: "#0A64A2", color: "#fff" }}
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={product.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {/* 
         

          {/* Delete Confirmation Dialog */}

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" }, // Set the width to 300px
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }} // Center align text
          >
            {markedForDelete.length > 0
              ? "Are you sure you want to delete this selected Product(s)?"
              : "Please select product(s) before deleting."}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          {" "}
          {/* Center-align the buttons */}
          {markedForDelete.length > 0 ? (
            <Button
              variant="contained"
              onClick={handleDeleteConfirm}
              className="no-btn"
            >
              Yes
            </Button>
          ) : (
            ""
          )}
          <Button
            variant="contained"
            onClick={handleClose}
            autoFocus
            className="no-btn"
          >
            {markedForDelete.length > 0 ? "No" : "Ok"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Product Selection Dialog */}
      <Dialog
        open={openProduct}
        onClose={handleCloseProduct}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" }, // Set the width to 300px
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }} // Center align text
          >
            Please select product before proceeding.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            onClick={handleCloseProduct}
            autoFocus
            className="no-btn"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      {/* Student Selection Dialog */}
      <Dialog
        open={openStudent}
        onClose={handleCloseStudent}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" }, // Set the width to 300px
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }} // Center align text
          >
            Kindly select a student before selecting any products.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            onClick={handleCloseStudent}
            className="no-btn"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      {/* Snackbar for errors */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          // onClose={handleCloseSnackbar}
          severity="error"
          variant="filled"
        >
          {error}
        </Alert>
      </Snackbar>
    </div>
  );
}
